export const ACCOUNT_LOCK_DURATION = "876000h"; // 100 years; an administrator can unlock sooner.

export function isAccountLocked(user: { banned_until?: string | null }, now = Date.now()): boolean {
  return Boolean(user.banned_until && Date.parse(user.banned_until) > now);
}

export function accountStatus(user: { banned_until?: string | null; email_confirmed_at?: string | null }, now = Date.now()) {
  return isAccountLocked(user, now) ? "Locked out" : user.email_confirmed_at ? "Active" : "Unconfirmed";
}

type DirectoryRequest = { action: "list" } | {
  action: "set_lock"; user_id: string; locked: boolean; expected_locked: boolean;
} | {
  action: "set_administrator"; user_id: string; administrator: boolean; expected_administrator: boolean;
};

export function parseAdminUsersRequest(value: unknown): DirectoryRequest | null {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const body = value as Record<string, unknown>;
  if ((body.action === undefined && Object.keys(body).length === 0) || body.action === "list") return { action: "list" };
  if (typeof body.user_id !== "string" ||
    !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(body.user_id)) return null;
  if (body.action === "set_administrator") {
    if (typeof body.administrator !== "boolean" || typeof body.expected_administrator !== "boolean") return null;
    return { action: "set_administrator", user_id: body.user_id, administrator: body.administrator,
      expected_administrator: body.expected_administrator };
  }
  if (body.action !== "set_lock" || typeof body.locked !== "boolean" || typeof body.expected_locked !== "boolean") return null;
  return { action: "set_lock", user_id: body.user_id, locked: body.locked, expected_locked: body.expected_locked };
}
